import axios from "axios";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { endpoint: String, pkey: String, callbackUrl: String, redirectUrl: String}

  connect() {
    initEzidebitInputs()
    this.initEzidebit()
    $("#creditCardForm").bootstrapMaterialDesign()
  }

  initEzidebit() {
    const pkey = this.pkeyValue
    const endpoint = this.endpointValue

    eziDebit.init(pkey, {
      submitAction: "SaveCustomer",
      submitButton: "signupCreditCardButton",
      submitCallback: (data) => this.submitSuccessCallback(data),
      submitError: (data) => this.displaySubmitError(data),
      customerReference: "systemReference", // In Ezidebit Online this is known as the Client Contract Ref. This is your reference for the customer
      customerLastName: "lastname",
      customerFirstName: "firstName", // If no first name is provided the customerLastName is assumed to be the Company Name
      customerAddress1: "address1",
      customerAddress2: "address2",
      customerSuburb: "suburb",
      customerState: "state",
      customerPostcode: "postcode",
      customerEmail: "email",
      customerMobile: "mobile",
      nameOnCard: "nameOnCard",
      cardNumber: "cardNumber",
      cardExpiryMonth: "expiryMonth",
      cardExpiryYear: "expiryYear",
    }, endpoint);
  }

  submitSuccessCallback(data) {
    if (data["ErrorMessage"] != null) {
      this.displaySubmitError(data["ErrorMessage"])
    } else {
      let directDebitData = data.Data

      Object.assign(directDebitData, {
        masked_card_number: maskString($("#cardNumber").val())
      });
      this.createPaymentMethod(directDebitData)
    }
  }

  displaySubmitError(data) {
    bootbox.alert({
      title: formatBootboxTitle(false, "Failed"),
      className: "failure-modal",
      message: data,
      callback: function() {
        enableSubmitButton("#signupCreditCardButton", "Submit")
      }
    })
  }

  createPaymentMethod(directDebitData) {
    const url = this.callbackUrlValue;
    const redirectUrl = this.redirectUrlValue;

    const authenticityToken = $('#creditCardForm input[name="authenticity_token"]').val();
    axios.post(url,  { authenticity_token: authenticityToken, direct_debit: directDebitData })
    .then(response => {
       bootbox.alert({
         title: formatBootboxTitle(true),
         className: "success-modal",
         message: "Your CREDIT CARD direct debit has been successfully set up.",
         callback: function () {
           window.location = redirectUrl;
         },
         closeButton: false
       });
    })
    .catch(error => {
      this.displaySubmitError(error)
    });
  }
}